import { validateRequiredField } from '../DynamicFormFields/DynamicFormFields.utils';
export function validateFormField(field, value) {
  return validateRequiredField(field, value);
}